import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${Breakpoints.desktop}px;
  margin: 0 auto 90px;
  aspect-ratio: 375 / 250;
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    max-height: 300px;
  }

  @media (max-width: ${Breakpoints.desktop}px) {
    padding: 0 40px;
    margin: 0 auto 70px;
  }

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    min-height: auto;
  }

  @media (min-width: ${Breakpoints.tablet}px) and (max-width: ${Breakpoints.smallDesktop}px) {
    height: 250px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    padding: 0 15px;
    margin-bottom: 70px;
  }
`;

export const Inner = styled.a<{ $bg: string }>`
  display: block;
  position: relative;
  width: 100%;
  max-width: ${Breakpoints.desktop}px;
  height: 100%;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  background-image: url(${p => p.$bg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  text-decoration: none;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 300px;
    background-size: 100% 100%;
    background-position: center;
  }
`;

export const Content = styled.div<{ $color: string }>`
  color: ${({ $color }) => $color};
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: flex-start;
  padding: 60px;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    padding: 25px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    padding: 20px;
  }
`;

export const Title = styled.h3`
  margin: 0 0 10px;
  font-weight: 700;
  font-size: 32px;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    font-size: 20px;
  }
`;

export const Text = styled.div`
  font-size: 20px;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    font-size: 15px;
  }
`;
